import React from 'react';

export const Copyright = (props) => {
    return <div {...props}>Copyright 2014 - {new Date().getFullYear()}</div>;
};

export const OrdersLink = (props) => {
    return <div {...props}><a href="mailto:orders@thumbprintsbakingco.com">orders@thumbprintsbakingco.com</a></div>;
};
